//#region libs
import { guid } from '../_strings';
//#endregion

export function nextId(): number {
  const NEXT: string = (new Date()).getTime().toString() + guid(5, 10);
  // console.log(NEXT);
  return Number(NEXT);
}
